import { TEmployeeWithId, TRESPONSE_GET_TNA_ORDER_STEP, TRESPONSE_GET_TNA_ORDER_STEP_LIST } from '@monorepo/types';
import { TAccordion, TAccordionActionInfo, TAccordionTableVM } from '../../model/accordion-table.types';
import { DateUtils, ShareUtil } from '@monorepo/utils';

const ACTION_DISPLAY_CONF: TAccordionActionInfo[] = [
  {
    actionId: 'STEP_COMPLETED',
    displayName: 'Mark as complete',
  },
  {
    actionId: 'SHARE_ON_WHATSAPP',
    displayName: 'Share on Whatsapp',
    hyperTxtConf: {
      href: '',
    },
  },
  {
    actionId: 'ADDED_ADDITIONAL_DETAILS',
    displayName: 'Add/View Additional details',
  },
  {
    actionId: 'STEP_IN_PROGRESS',
    displayName: 'Mark as In-Progress',
  },
];

const TNA_STEPS_ACTIONS_CONF = {
  actions: [
    {
      status: 'OVERDUE',
      actionIds: ['STEP_COMPLETED', 'ADDED_ADDITIONAL_DETAILS', 'SHARE_ON_WHATSAPP', 'STEP_IN_PROGRESS'],
    },
    {
      status: 'TODAY',
      actionIds: ['STEP_COMPLETED', 'ADDED_ADDITIONAL_DETAILS', 'SHARE_ON_WHATSAPP', 'STEP_IN_PROGRESS'],
    },
    {
      status: 'UPCOMING',
      actionIds: ['STEP_COMPLETED', 'ADDED_ADDITIONAL_DETAILS', 'SHARE_ON_WHATSAPP', 'STEP_IN_PROGRESS'],
    },
  ],
};

function _getactionsInfoByStatus(selectedTicketStatus: string) {
  const actionsFilteredByStatus = TNA_STEPS_ACTIONS_CONF.actions.find(
    (action) => action.status === selectedTicketStatus,
  );
  if (actionsFilteredByStatus) {
    return ACTION_DISPLAY_CONF.filter((actionInfo) =>
      actionsFilteredByStatus.actionIds.includes(actionInfo.actionId as string),
    );
  } else {
    return [];
  }
}

function _mapToValuesList(stringList: string[] | number[]) {
  return stringList.map((str) => {
    return {
      displayName: str,
    };
  });
}

function _getEmployeesStr(employees: TEmployeeWithId[]) {
  return employees.map((emp) => `${emp.employeeName} (${emp.employeeId})`);
}

export const TNA_STEPS_ACCORDION_TABLE_MODEL = {
  //TODO[jyotishka]: using old creation flow. add updateModelOnTnaStepUpdate() and resetTnaStepInModel()
  // to modifier and pipeline and update to new creation flow

  createModel(
    tnaOrderStepItemList?: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'],
    selectedTicketStatus?: string,
  ): TAccordionTableVM {
    const allActions =
      selectedTicketStatus && tnaOrderStepItemList?.length ? _getactionsInfoByStatus(selectedTicketStatus) : [];

    return {
      headers: [
        { label: 'STEPS', colSize: 9 },
        { label: 'BUYER', colSize: 7 },
        { label: 'TARGET DATE', colSize: 7 },
        { label: 'DATE FROM PLAN', colSize: 7 },
      ],
      options: {
        select: {
          isMulti: true,
          selectAllApplicable: true,
        },
      },
      accordions: tnaOrderStepItemList
        ? tnaOrderStepItemList.map((tnaStep): TAccordion => {
            return {
              id: tnaStep.tosId,
              tag: [
                {
                  displayName: tnaStep.userOrderTnaId,
                  frequency: 1,
                  class: 'accordian-table__tag--data',
                },
                ...(tnaStep.expectedDate
                  ? [
                      {
                        displayName: `Expected Date: ${tnaStep.expectedDate}`,
                        frequency: 1,
                        class: 'accordian-table__tag--blue',
                      },
                    ]
                  : []),
                ...(tnaStep.isPrerequisiteStepsComplete
                  ? [
                      {
                        displayName: 'Pre-requisite Steps Complete',
                        frequency: 1,
                        class: 'accordian-table__tag--green',
                      },
                    ]
                  : []),
              ],
              isMinimized: true,
              rowItems: [
                {
                  type: 'TEXT',
                  value: tnaStep.step,
                  icon: tnaStep.isInProgress === 'yes' ? 'IN_PROGRESS' : undefined,
                  actionIconId: 'COPY',
                },
                { type: 'TEXT', value: tnaStep.buyer },
                { type: 'TEXT', value: DateUtils.getDisplayDateStringFromDate(tnaStep.targetDate) },
                {
                  type: 'TEXT',
                  value: tnaStep.dateFromPlan ? DateUtils.getDisplayDateStringFromDate(tnaStep.dateFromPlan) : '--',
                },
              ],
              moreInfo: [],
              actions:
                tnaStep.isInProgress === 'yes'
                  ? allActions.filter((a) => a.actionId !== 'STEP_IN_PROGRESS')
                  : allActions,
            };
          })
        : [],
    };
  },

  updateModelOnTnaStepUpdate(
    tnaStepItem: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number],
    tnaStep: TRESPONSE_GET_TNA_ORDER_STEP,
    accordianTable: TAccordionTableVM,
  ): TAccordionTableVM {
    return {
      ...accordianTable,
      accordions: accordianTable.accordions.map((accordian): TAccordion => {
        if (accordian.id === tnaStepItem.tosId) {
          return {
            ...accordian,
            isMinimized: false,
            moreInfo: [
              {
                items: [
                  {
                    size: 12,
                    label: 'Responsible Team',
                    values: _mapToValuesList([tnaStep.tnaOrderStepDetailsDTO.responsibleTeam]),
                  },
                  {
                    size: 12,
                    label: 'People in-charge',
                    values: _mapToValuesList(_getEmployeesStr(tnaStep.tnaOrderStepDetailsDTO.employees)),
                  },
                  {
                    size: 12,
                    label: 'Pre-requisite',
                    values: _mapToValuesList(
                      tnaStep.tnaOrderStepDetailsDTO.preRequisites.map(
                        (preRequisite) =>
                          `${preRequisite.step} : ${_getEmployeesStr(preRequisite.employees).join(', ')} : ${
                            preRequisite.status
                          }`,
                      ),
                    ),
                  },
                  {
                    size: 12,
                    label: 'Build allowance',
                    values: _mapToValuesList(
                      tnaStep.tnaOrderStepDetailsDTO.buildAllowance
                        ? [tnaStep.tnaOrderStepDetailsDTO.buildAllowance + ' days']
                        : ['--'],
                    ),
                  },
                ],
              },
              {
                sectionName: 'PCD',
                items: [
                  {
                    size: 12,
                    label: 'Target Date',
                    values: _mapToValuesList([tnaStep.tnaOrderStepDetailsDTO.pcd.pcdTargetDate ?? '--']),
                  },
                  {
                    size: 12,
                    label: 'Expected Date',
                    values: _mapToValuesList([tnaStep.tnaOrderStepDetailsDTO.pcd.pcdExpectedDate ?? '--']),
                  },
                  {
                    size: 12,
                    label: 'Completed Date',
                    values: _mapToValuesList([tnaStep.tnaOrderStepDetailsDTO.pcd.pcdCompletionDate ?? '--']),
                  },
                ],
              },
              {
                sectionName: 'Order details',
                items: [
                  {
                    size: 12,
                    label: 'Order Id',
                    values: [
                      {
                        displayName: tnaStep.orderDetailsDTO.orderId,
                        routerLink: `/orders/details/${tnaStep.orderDetailsDTO.otlId}`,
                      },
                    ],
                    type: 'ROUTER_LINK',
                  },
                  {
                    size: 12,
                    label: 'Buyer',
                    values: _mapToValuesList([tnaStep.orderDetailsDTO.buyer]),
                    type: 'LOCATION',
                  },
                  {
                    size: 12,
                    label: 'Earlier Delivery Date',
                    values: _mapToValuesList([
                      DateUtils.getDisplayDateStringFromDate(tnaStep.orderDetailsDTO.minDeliveryDate),
                    ]),
                  },
                  {
                    size: 12,
                    label: 'Style',
                    values: _mapToValuesList([tnaStep.orderDetailsDTO.style]),
                  },
                  {
                    size: 12,
                    label: 'Latest Delivery Date',
                    values: _mapToValuesList([
                      DateUtils.getDisplayDateStringFromDate(tnaStep.orderDetailsDTO.maxDeliveryDate),
                    ]),
                  },
                  {
                    size: 12,
                    label: 'Product Type',
                    values: _mapToValuesList(tnaStep.orderDetailsDTO.productTypes),
                  },
                  {
                    size: 12,
                    label: 'Season',
                    values: _mapToValuesList([tnaStep.orderDetailsDTO.season]),
                  },
                  ...(tnaStep.orderDetailsDTO.erp !== null && tnaStep.orderDetailsDTO.erp !== undefined
                    ? [
                        {
                          size: 12 as const,
                          label: 'ERP',
                          values: _mapToValuesList([tnaStep.orderDetailsDTO.erp]),
                        },
                      ]
                    : []),
                  ...(tnaStep.orderDetailsDTO.color !== null && tnaStep.orderDetailsDTO.color !== undefined
                    ? [
                        {
                          size: 12 as const,
                          label: 'Color',
                          values: _mapToValuesList([tnaStep.orderDetailsDTO.color]),
                        },
                      ]
                    : []),
                  ...(tnaStep.orderDetailsDTO.po !== null && tnaStep.orderDetailsDTO.po !== undefined
                    ? [
                        {
                          size: 12 as const,
                          label: 'PO',
                          values: _mapToValuesList([tnaStep.orderDetailsDTO.po]),
                        },
                      ]
                    : []),
                  {
                    size: 12,
                    label: 'Additional Details',
                    values: _mapToValuesList([tnaStep.tnaOrderStepDetailsDTO.additionalDetails ?? '- -']),
                  },
                ],
              },
            ],
            editableInfo: [
              {
                items: [
                  {
                    size: 12,
                    label: 'Expected Date',
                    icon: 'assets/common/edit.svg',
                    actionDislayName: 'Add Expected Date',
                    actionId: 'ADD_UPDATE_EXPECTED_DATE',
                    value: tnaStep.tnaOrderStepDetailsDTO.expectedDate
                      ? tnaStep.tnaOrderStepDetailsDTO.expectedDate
                      : undefined,
                  },
                ],
              },
            ],
            actions: accordian.actions.map((action) => {
              if (action.hyperTxtConf) {
                return {
                  ...action,
                  hyperTxtConf: {
                    href: ShareUtil.getWhatsAppShareLink(tnaStep.message),
                    icon: 'assets/common/whatsapp-icon.svg',
                  },
                };
              } else {
                return action;
              }
            }),
          };
        } else {
          return accordian;
        }
      }),
    };
  },

  resetTnaStepInModel(
    accordianTable: TAccordionTableVM,
    tosId: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number]['tosId'],
  ): TAccordionTableVM {
    return {
      ...accordianTable,
      accordions: accordianTable.accordions.map((accordian) => {
        if (accordian.id === tosId) {
          return {
            ...accordian,
            moreInfo: [],
          };
        } else {
          return accordian;
        }
      }),
    };
  },
};
